import React from "react"
import QuoteCard from "../components/card/QuoteCard";

export const Quote = () => {
    return(
        <QuoteCard />
    );
}